// libs
import React from 'react';

import * as ContentDetails from '@/components/ContentDetails';
// hooks
import { useHeroContext } from '@/modules/corporate/components/DetailPageComponents/DetailHero/context';

import { HeroComposition } from '../../types';

const Duration: HeroComposition['Duration'] = ({ className }) => {
  const {
    content: { duration },
  } = useHeroContext();

  const content = {
    duration,
  };

  if (!duration) {
    return null;
  }

  return (
    <ContentDetails.Provider content={content}>
      <ContentDetails.Duration className={className} />
    </ContentDetails.Provider>
  );
};

export default Duration;
